import { Guild,  CreateGuildDto, UpdateGuildDto, GetGuildByIdDto } from '../types/Guilds'
import { timeoffApi } from './timeoff.api'

const guildEndpoints = timeoffApi.injectEndpoints({
  endpoints: build => ({
    getAllGuilds: build.query<Guild[], void>({
      query: () => `/guild/allguilds`,
      providesTags: ['Guild'],
    }),
    getGuildById: build.query<Guild, GetGuildByIdDto>({
      query: data => `/guild/${data.id}`,
      providesTags: ['Guild'],
    }),
    createGuild: build.mutation<Guild, CreateGuildDto>({
      query: data => ({
        url: `/guild/create`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Guild'],
    }),
    updateGuild: build.mutation<Guild, UpdateGuildDto>({
      query: data => ({
        url: `/guild/update/${data.id}`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Guild'],
    }),
  }),
})

export const {
  useGetAllGuildsQuery,
  useLazyGetAllGuildsQuery,
  useGetGuildByIdQuery,
  useLazyGetGuildByIdQuery,
  useCreateGuildMutation,
  useUpdateGuildMutation
} = guildEndpoints
